import "../../../assets/scss/instance-details-style.scss";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  AppstoreOutlined,
  BranchesOutlined,
  CopyOutlined,
  DesktopOutlined,
  HistoryOutlined,
  InteractionOutlined,
  MoneyCollectOutlined,
  DatabaseOutlined,
  RobotOutlined,
  ThunderboltFilled,
} from "@ant-design/icons";

import { Button, Divider, Input, Modal, Skeleton, Spin, message } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  getInstanceSSHCommand,
  updateInstancePublicKey,
  stopInstanceRent,
  getInstanceDetail,
} from "../../server/Instances";
import { calculateTime } from "../../utility/common/common";
import {
  chooseInstance,
  updatePublicKey,
} from "../../features/instance/instanceSlice";
import { Field, Form, Formik } from "formik";
import { randomNumber } from "../../utility/fn";

const contentStyle: React.CSSProperties = {
  padding: 50,
};

const content = <div style={contentStyle} />;

export const InstanceDetail = () => {
  const { t } = useTranslation();
  const instanceState = useAppSelector((state: any) => state.instance);
  const userState = useAppSelector((state: any) => state.user);
  const settingsState = useAppSelector((state: any) => state.settings);
  const instanceLoadingStatusState = useAppSelector(
    (state: any) => state.instanceStatus.id
  );
  const [loading, setLoading] = useState(false);
  const [rentalSummary, setRentalSummary] = useState<any>(null);
  const [finalTimeConsumed, setFinalTimeConsumed] = useState<number>(0);
  const [stoppedRental, setStoppedRental] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [isSSHModalOpen, setIsSSHModalOpen] = useState(false);
  const [SSHCommand, setSSHCommand] = useState("");
  const [interalIP, setInteralIP] = useState("");
  const [secretPassword, setSecretPassword] = useState("");
  // const [checkOutModal, setCheckOutModal] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // 結束租用時，需要抓最新的時間去計算
  const stopInstanceRental = async () => {
    setLoading(true);
    setStoppedRental(true);
    const response = await stopInstanceRent(
      instanceState.instance_id,
      instanceState.host_id
    );
    const data = await response.data;
    if (data.code === 0) {
      dispatch(
        chooseInstance({
          ...instanceState,
          time_consumed: data.time_consumed,
        })
      );

      setFinalTimeConsumed(data.time_consumed);
      setLoading(false);
      setRentalSummary(data);
    }
  };

  const calculateTotal = (unit_price: number, time: number) => {
    let total = 0;
    total = unit_price * time * instanceState.gpu_count;
    let newTotal = total.toFixed(2);
    return Number(newTotal);
  };

  const calculatePerHour = (unit_price: number, gpu_count: number) => {
    let total = 0;
    total = unit_price * gpu_count;
    let newTotal = total.toFixed(2);
    return newTotal;
  };

  const startSSHInstance = () => {
    getInstanceSSHCommand(userState.user_id, instanceState.instance_id)
      .then((res) => setSSHCommand(res.data.ssh_cmd))
      .catch((err) => console.log(err));
  };

  const handleSSHOk = () => {
    setIsSSHModalOpen(false);
  };

  const handleSSHCancel = () => {
    setIsSSHModalOpen(false);
  };

  const addedInstanceKeySuccess = () => {
    messageApi.success(t("Instance Key Added Success!"), 2.5);
  };

  const addedInstanceKeyFailed = () => {
    messageApi.error(t("Instance Key Added Failed!"), 2.5);
  };

  const paymentProgress = () => {
    messageApi
      .open({
        type: "loading",
        content: t("Payment In Progress..."),
        duration: 2.5,
      })
      .then(() => message.success(t("Payment Success!"), 2.5))
      .then(() => navigate("/"));
  };

  const getDetails = () => {
    getInstanceDetail(instanceState.instance_id)
      .then((res) => {
        setInteralIP(res.data.instance.internal_ip);
        setSecretPassword(res.data.instance.ssh_password);
        setSSHCommand(res.data.instance.ssh_url);
        dispatch(chooseInstance(res.data.instance));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkLoadingStatus = () => {
    const foundInstance = instanceLoadingStatusState.find((item: any) =>
      window.location.pathname.includes(item.instanceID)
    );

    if (foundInstance !== undefined) {
      navigate("/instances");
    }
  };
  useEffect(() => {
    checkLoadingStatus();
    getDetails();
  }, []);

  return (
    <>
      <div className="wrapper">
        {contextHolder}
        <div className="instance-detail-top">
          {loading ? (
            <div className="instance-loading-wrapper">
              <Spin size="large">{content}</Spin>
              <span>{t("Ending service and calculating final cost...")}</span>
            </div>
          ) : (
            <div className="instance-detail-card">
              <ul className="instance-detail-card-details">
                <li>
                  <DesktopOutlined /> ID: {instanceState.instance_id}
                </li>
                <li>
                  <RobotOutlined /> {t("GPU Type")}:{" "}
                  {instanceState.product_name}
                </li>{" "}
                <li>
                  <BranchesOutlined /> {t("Node Name")}:{" "}
                  {instanceState.node_name}
                </li>
                <li>
                  <DatabaseOutlined /> {t("GPU Count")}:{" "}
                  {instanceState.gpu_count} GPU
                </li>{" "}
                <li>
                  <AppstoreOutlined /> {t("Template Name")}:{" "}
                  {instanceState.template_name}
                </li>
                <li>
                  <HistoryOutlined /> {t("Time Used")}:{" "}
                  {calculateTime(
                    instanceState.time_consumed,
                    settingsState.lang
                  )}
                </li>
                {/* <li>
                  <ThunderboltFilled /> {t("Total Watt Used")}:{" "}
                  {randomNumber(22, 80)} kWatt
                </li> */}
                <li>
                  <MoneyCollectOutlined /> {t("Price")}: USD ${" "}
                  {calculatePerHour(
                    instanceState.price,
                    instanceState.gpu_count
                  )}
                  /{t("hours")}
                </li>
                <li>
                  <InteractionOutlined /> {t("Total Amount To Be Paid")}: USD ${" "}
                  {calculateTotal(
                    instanceState.price,
                    Number(instanceState.time_consumed) / 3600 // cal to min
                  )}{" "}
                  {settingsState.lang === "zh_tw" && "元"}
                </li>
              </ul>
            </div>
          )}
          <div className="options-container">
            {rentalSummary ? (
              <a
                className="esg-export-btn"
                href="http://35.208.11.10:5043/api/download-excel?Content-Type=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet&Content-Disposition=attachment; filename=Walmart Inc.-Overall-All Quadrants-2025-03-13.xlsx"
                style={{ display: "none" }}
              >
                {t("ESG Report Export")}
              </a>
            ) : (
              <>
                <Button
                  type="primary"
                  disabled={stoppedRental}
                  onClick={() => {
                    stopInstanceRental();
                  }}
                >
                  {t("End Rental")}
                </Button>
                <Button
                  type="primary"
                  disabled={stoppedRental}
                  onClick={() => {
                    navigate("/dockerList");
                  }}
                >
                  {t("View File List")}
                </Button>
                {instanceState.service_url && (
                  <Button
                    disabled={stoppedRental}
                    href={instanceState.service_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Use Services")}
                  </Button>
                )}
                {SSHCommand !== "" && (
                  <Input
                    style={{ margin: "0em 0 .25em 0" }}
                    disabled={stoppedRental}
                    value={SSHCommand}
                    suffix={
                      <CopyOutlined
                        onClick={() =>
                          navigator.clipboard.writeText(SSHCommand)
                        }
                        style={{
                          cursor: "pointer",
                          fontSize: 16,
                        }}
                      />
                    }
                  />
                )}
                {secretPassword !== "" && (
                  <Input
                    style={{ margin: ".5em 0" }}
                    disabled={stoppedRental}
                    value={secretPassword}
                    type="password"
                    suffix={
                      <CopyOutlined
                        onClick={() =>
                          navigator.clipboard.writeText(secretPassword)
                        }
                        style={{
                          cursor: "pointer",
                          fontSize: 16,
                        }}
                      />
                    }
                  />
                )}
                {interalIP !== "" && (
                  <Input
                    style={{ margin: "0em 0 .25em 0" }}
                    disabled={stoppedRental}
                    value={interalIP}
                    suffix={
                      <CopyOutlined
                        onClick={() => navigator.clipboard.writeText(interalIP)}
                        style={{
                          cursor: "pointer",
                          fontSize: 16,
                        }}
                      />
                    }
                  />
                )}
              </>
            )}
          </div>
        </div>
        {rentalSummary && (
          <>
            <Divider />
            <div className="rental-summary">
              <div className="payment-total">
                <div className="total">
                  <div className="total-cal-chart">
                    <ul>
                      <li>
                        <span className="cost-title">{t("Product Price")}</span>
                        <span>
                          USD ${Number(rentalSummary.unit_price).toFixed(2)} /
                          {t("hours")}
                        </span>
                      </li>
                      <li>
                        <span className="cost-title">GPU {t("GPU Count")}</span>
                        <span>
                          {instanceState.gpu_count} {t("GPUs")}
                        </span>
                      </li>
                      <li>
                        <span className="cost-title">
                          {t("Total Time Used")}
                        </span>
                        <span>
                          {calculateTime(finalTimeConsumed, settingsState.lang)}
                        </span>
                      </li>
                      {/* <li>
                        <span className="cost-title">
                          {t("Total Watt Used")}
                        </span>
                        <span>
                          {randomNumber(22, 80) *
                            Math.ceil(Number(finalTimeConsumed) / 3600)}
                          kWatt
                        </span>
                      </li> */}
                      <li>
                        <span className="cost-title">
                          {t("Total Amount To Be Paid")}
                        </span>
                        <span className="total-price">
                          USD $
                          {calculateTotal(
                            rentalSummary.unit_price,
                            Number(finalTimeConsumed) / 3600
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <Button type="primary" onClick={() => paymentProgress()}>
                  {t("Pay")}
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
      <Modal
        title={t("Please Add a Public Key...")}
        open={isSSHModalOpen}
        onOk={handleSSHOk}
        onCancel={handleSSHCancel}
        footer={null}
      >
        <Formik
          validateOnMount={true}
          enableReinitialize={true}
          initialValues={{}}
          onSubmit={(values: any) => {
            const data = {
              ...values,
              instance_id: instanceState.instance_id,
            };
            setLoading(true);
            dispatch(updatePublicKey(values.public_key));
            updateInstancePublicKey(userState.user_id, data)
              .then((res) => {
                if (res.data.msg == "success") {
                  setLoading(false);
                  addedInstanceKeySuccess();
                  handleSSHCancel();
                  startSSHInstance();
                }
              })
              .catch((res) => {
                setLoading(false);
                addedInstanceKeyFailed();
                handleSSHCancel();
              });
          }}
        >
          <Form className="add-key-form">
            {loading ? (
              <Skeleton active />
            ) : (
              <Field name="public_key" as="textarea" />
            )}
            <button className="add-key-btn" disabled={loading} type="submit">
              {t("Add Public Key")}
            </button>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};
